import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-nav', 'search', 'Поиск');
Labels.set('ui-nav', 'searchOpen', 'Открыть форму поиска');
Labels.set('ui-nav', 'searchClose', 'Закрыть форму поиска');
